import { Action } from '@ngrx/store';

export const FINALIZE_EXTRACT_SUCCESS = '[Extract] Finalize Extract Success';

export class FinalizeExtractSuccessAction implements Action {
  readonly type = FINALIZE_EXTRACT_SUCCESS;
}



// WEBPACK FOOTER //
// ./src/app/extracts/store/actions/FinalizeExtractSuccessAction.ts